import { inject, Injectable } from '@angular/core';
import { TrailingIcon } from '../interfaces/navigation-item.interface';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TrailingIconsService {
	private readonly translocoService = inject(TranslocoService);

	// Hinweis: kein iconName mehr — die Darstellung erfolgt durchgaengig ueber
	// ara-info-badge (1-Buchstaben-Label im araTheme, vollstaendiger Titel sonst).
	// Der `iconName`-Bedarf ist damit obsolet; `title` bleibt das Identifikations-
	// merkmal fuer die Badge-Variant-Detection (BETA/ALPHA/SOON).

	get BETA(): TrailingIcon {
		return {
			title: 'BETA',
			text: this.translocoService.translate('common.betaFeature'),
			externalUrl: 'https://arasys.atlassian.net/servicedesk/customer/portal/6/article/710344711',
		};
	}

	get ALPHA(): TrailingIcon {
		return {
			title: 'ALPHA',
			text: this.translocoService.translate('common.alphaFeature'),
		};
	}

	get SOON(): TrailingIcon {
		return {
			title: 'SOON',
			text: this.translocoService.translate('common.comingSoon'),
		};
	}
}
